import React from "react";
import Logo from "assets/images/yoma-logo-circular.svg";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
0% {
    transform: rotate(0deg)
}

100% {
    transform: rotate(360deg)
}
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: center;
`;

const SpinnerComponent = styled.img`
  animation: ${spin} 2s infinite linear;
  height: 75px;
  margin-bottom: 16px;
`;

const Spinner = () => (
  <Container>
    <SpinnerComponent src={Logo} />
  </Container>
);

export default Spinner;
